const styles = {
  section: {
    display: "flex",
    padding: "0px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "var(--Spacing-spacing-16, 16px)",
    flex: "1 0 0",
    borderTop: "1px solid var(--Colors-Border-Gray-150, #D0D0D0)",
  },
  card: {
    height: "100%",
    display: "flex",
    minWidth: "280px",
    padding: "16px",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "8px",
    alignSelf: "stretch",
    flexWrap: "wrap",
    borderRadius: "4px",
    background: "var(--Tokens-Background-Default, #F3F7FD)",
  },
  typography: {
    color: "var(--Tokens-Text-Black, #000)",
    fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
    fontSize: "var(--Font-Size-H6, 18px)",
    fontWeight: 700,
    lineHeight: "var(--Line-Height-H6, 28px)",
  },
  buttonBox: {
    display: "flex",
    flexDirection: "row",
    gap: "2px",
    paddingY: "4px",
    cursor: "pointer",
  },
  buttonText: {
    color: "var(--Tokens-Button-Borderless, #005CBC)",
    fontFamily: "var(--Typography-Font-Family-Body, Inter)",
    fontSize: "var(--Font-Size-Small, 14px)",
    fontWeight: 700,
    lineHeight: "var(--Line-Height-Small, 20px)",
    textTransform: "none",
  },
  actionsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    gap: "32px",
    marginY: "auto",
  },
};

export default styles;
